<div class="add-topic-modal">
    <Modal
        id="add-topic-modal-id"
        bodyHtml={body}
        titleText={config.addTopicText}
        enabled={enableAddTopicModal}
        on:close={cancel}
    >
        <div slot="body">
            <div class="topic-modal__info">{i18n.topicInformation}</div>
            <RadioGroup
                options={topicsList}
                name={topicRadioGroup}
                id="add-topic-radio-group-id"
                label={config.selectTopicText}
                bind:selected={selectedTopic}
                {selectedTopicLabel}
                useSmallRadioButtons={true}
                on:selected={selectedAction}
            />
        </div>

        <div slot="footer" class="add-topic-modal__footer-buttons">
            <Button
                type="primary"
                large={true}
                text={i18n.addTopic}
                disabled={false}
                on:click={addTopic}
            />
            <Button type="secondary" large={true} text={i18n.createNew} on:click={createNewTopic} />
            <Button type="plain" large={true} text={i18n.cancel} on:click={cancel} />
        </div>
    </Modal>
</div>

<script>
    import Button from "@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte";
    import Modal from "@itslearning/prometheus/assets/modals/Modal/v2/Modal.svelte";
    import RadioGroup from "@itslearning/prometheus/assets/inputs/RadioGroup/v1/RadioGroup.svelte";
    import { createEventDispatcher, onMount, tick } from "svelte";
    import { getTopics } from "../../api";
    import i18n from "../../i18n";
    import config from "../../config";

    export let enableAddTopicModal;
    export let body;
    export let topicRadioGroup = "topic-radio-group";
    export let topicsList = [];
    export let selectedTopic;
    export let selectedTopicLabel;
    export let moveResourcesCandidate;
    export let initialTopicId;

    $: useMoveResourcesFlow = moveResourcesCandidate && selectedTopic != initialTopicId;

    onMount(() => {
        if (!config.publicAccessKey) {
            getTopics(config.filterPersonId).then(result => {
                const tempArray = [];

                result
                    .filter(r => r.id && r.name)
                    .forEach(t =>
                        tempArray.push({
                            label: t.name,
                            id: t.id.toString(),
                            disabled: false,
                            value: t.id
                        })
                    );
                topicsList = tempArray;

                if (tempArray.length > 0) {
                    setInitValue(tempArray[0].value, tempArray[0].label);
                }
            });
        }
    });

    async function setInitValue(startValue, startLabel) {
        await tick();
        const focusElement = document.querySelector(".prom-radio-button__input");

        if (focusElement) {
            focusElement.focus();
        }

        selectedTopic = startValue;
        selectedTopicLabel = startLabel;
    }

    const dispatch = createEventDispatcher();

    function addTopic() {
        dispatch("addTopic", {
            topicId: selectedTopic, topicLabel: selectedTopicLabel, useMoveResources: useMoveResourcesFlow
        });
    }

    function createNewTopic() {
        dispatch("openCreateTopicModal");
    }

    function cancel() {
        dispatch("cancel");
    }

    function selectedAction(event) {
        selectedTopic = event.detail.value;
        const selectedTopicItem = topicsList.filter(t => t.value === selectedTopic);

        selectedTopicLabel = selectedTopicItem ? selectedTopicItem[0].label : "?";
    }
</script>
